import { render, staticRenderFns } from "./BodiesItem.vue?vue&type=template&id=e86e818c&"
import script from "./BodiesItem.vue?vue&type=script&lang=js&"
export * from "./BodiesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports